import {useMemo, useState} from 'react'

import type {PipelineBaseRepository} from '../PipelineRepositories.types'
import {
  excludeRE,
  getJoinedMatches,
  getRepositoryName,
  includeRE,
} from '../PipelineRepositories.utils'

function usePipelineRepository(
  branch: string,
  repositoryUrl: string,
  branchSpec: string,
  editMode: boolean,
  isDeleted: boolean,
  isRoot: boolean,
  onDelete?: () => void,
  onConfirm?: (vcsRoot: PipelineBaseRepository) => void,
) {
  const [isEditMode, setEditMode] = useState<boolean>(editMode)
  const {included, excluded} = useMemo(() => {
    const lines = branchSpec.split('\n')
    return {
      included: getJoinedMatches(lines, includeRE),
      excluded: getJoinedMatches(lines, excludeRE),
    }
  }, [branchSpec])
  const addVcsRootHandler = (value: PipelineBaseRepository) => {
    onConfirm?.(value)
    setEditMode(false)
  }
  const branchSpecLabel = included
    ? `Included branches: ${included}${excluded ? `, excluded: ${excluded}` : ''}`
    : excluded
      ? `Excluded branches: ${excluded}`
      : ''
  const deleteRepositoryHandler = () => {
    setEditMode(false)
    onDelete?.()
  }
  const toggleEditModeHandler = (state: boolean) => () => !isDeleted && setEditMode(state)
  const canDeletable = onDelete && !isDeleted
  const canEditable = !isDeleted
  const canRestable = !isRoot && isDeleted
  const repositoryName = getRepositoryName(repositoryUrl)
  const deleteRepositoryFormHandler = !isRoot && branch ? deleteRepositoryHandler : undefined

  return {
    isEditMode,
    deleteRepositoryFormHandler,
    repositoryName,
    canEditable,
    canDeletable,
    canRestable,
    included,
    excluded,
    branchSpecLabel,
    toggleEditModeHandler,
    addVcsRootHandler,
    deleteRepositoryHandler,
  }
}

export default usePipelineRepository
